"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var moment = require("moment");
var core_1 = require("@athena-portal/core");
var Footer_1 = require("./Footer");
var LvFlowProgressBarWidget_1 = require("./progressBar/LvFlowProgressBarWidget");
var journey_services_1 = require("@athena-portal/journey-services");
var services_1 = require("@falcon/services");
var MotorProgressBarSettings_1 = require("./progressBar/MotorProgressBarSettings");
var RentersProgressBarSettings_1 = require("./progressBar/RentersProgressBarSettings");
var commonFunctions_1 = require("../commonFunctions");
var MaintenanceBannerWidget_1 = require("../widgets/MaintenanceBannerWidget");
var WolfMotorProgressBarSettings_1 = require("./progressBar/WolfMotorProgressBarSettings");
var AnnualHomeProgressBarSettings_1 = require("./progressBar/AnnualHomeProgressBarSettings");
var LvFalconNavigator = /** @class */ (function (_super) {
    __extends(LvFalconNavigator, _super);
    function LvFalconNavigator(props) {
        var _this = _super.call(this, props) || this;
        _this.skipDefault = function (event) {
            event.preventDefault();
        };
        _this.renderAllianzOnlineBadge = function (title) {
            return ((0, jsx_runtime_1.jsx)("div", { className: "allianz-online-badge allianz-online-badge--nb ".concat(!title ? 'allianz-online-badge--no-title' : ''), children: (0, jsx_runtime_1.jsx)("img", { className: "brand-badge", src: "/".concat(services_1.resourcesHelper.THEME, "/img/allianz-online-badge.svg"), alt: "".concat(services_1.resourcesHelper.PRODUCT, " badge") }) }));
        };
        _this.showProgressBar = true;
        _this.showBackground = true;
        _this.showLock = false;
        _this.showTitle = true;
        _this.isMotorProduct = services_1.productHelper.isMotor(_this.props.interaction);
        _this.isRentersProduct = services_1.productHelper.isRenters(_this.props.interaction);
        _this.isWolfProduct = services_1.productHelper.isWolfMotor(_this.props.interaction);
        _this.isHomeProduct = services_1.productHelper.isHome(_this.props.interaction);
        if (_this.isMotorProduct) {
            _this.progressBarSettings = new MotorProgressBarSettings_1.MotorProgressBarSettings();
        }
        else if (_this.isWolfProduct) {
            _this.progressBarSettings = new WolfMotorProgressBarSettings_1.WolfMotorProgressBarSettings();
        }
        else if (_this.isRentersProduct) {
            _this.progressBarSettings = new RentersProgressBarSettings_1.RentersProgressBarSettings();
        }
        else if (_this.isHomeProduct) {
            _this.progressBarSettings = new AnnualHomeProgressBarSettings_1.AnnualHomeProgressBarSettings();
        }
        _this.state = {
            errorShown: false,
            bannerShown: false,
            backgroundStyle: { height: "0px", top: "0px" }
        };
        _this.clickPrev = _this.clickPrev.bind(_this);
        _this.preClickNext = _this.preClickNext.bind(_this);
        _this.clickNext = _this.clickNext.bind(_this);
        _this.clickLogo = _this.clickLogo.bind(_this);
        return _this;
    }
    LvFalconNavigator.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var _a, _b, _c;
        var errorShown = false;
        for (var _i = 0, _d = Object.keys(this.props.validations); _i < _d.length; _i++) {
            var questionName = _d[_i];
            var validationResult = this.props.validations[questionName];
            if (validationResult.errors && validationResult.errors.length > 0) {
                errorShown = true;
            }
        }
        var bannerShown = (_c = (_b = (_a = this.props.interaction) === null || _a === void 0 ? void 0 : _a.uistate) === null || _b === void 0 ? void 0 : _b.showDlnPriceUpdateBanner) !== null && _c !== void 0 ? _c : false;
        if (prevState.errorShown !== errorShown || prevState.bannerShown !== bannerShown) {
            this.getJourneyBackground();
        }
    };
    LvFalconNavigator.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () {
            _this.getJourneyBackground();
        }, 500);
        window.addEventListener('resize', this.getJourneyBackground.bind(this));
    };
    LvFalconNavigator.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.getJourneyBackground);
    };
    LvFalconNavigator.prototype.componentDidCatch = function (error, errorInfo) {
        this.journeyRuntimeService.doBackendAction("log", this.props.interaction, {
            level: "ERROR",
            message: "JRE: exception: ".concat(error.message ? error.message : "", "\n    Interaction id: ").concat(this.props.interaction._id || "-", "\n    Product: ").concat(this.props.product || "-", "\n    Process: ").concat(this.props.process || "-", "\n    Page: ").concat(this.props.page && this.props.page.pageId, "\n    ComponentStack: ").concat(errorInfo.componentStack || "-", "\n    Stack: ").concat(error.stack || "-")
        }, false).subscribe();
    };
    LvFalconNavigator.prototype.renderPageTitle = function () {
        var _a;
        var page = this.props.page;
        var pageTitleClassName = (page === null || page === void 0 ? void 0 : page.pageId) === 'quote' ? 'quote-title' : '';
        var pageTitle = (_a = page === null || page === void 0 ? void 0 : page.title) !== null && _a !== void 0 ? _a : "";
        if ((page === null || page === void 0 ? void 0 : page.pageId) === "paymentDirectDebit" && services_1.resourcesHelper.THEME === "Britannia") {
            return ((0, jsx_runtime_1.jsxs)("h1", { className: pageTitleClassName, children: [(0, jsx_runtime_1.jsx)("span", { className: "secure-payment-icon" }), this.splitTitle(pageTitle)] }));
        }
        if (this.showLock) {
            return ((0, jsx_runtime_1.jsx)("h1", { className: pageTitleClassName, children: (0, jsx_runtime_1.jsx)("span", { className: "secure-payment-icon", children: pageTitle }) }));
        }
        return (0, jsx_runtime_1.jsx)("h1", { className: pageTitleClassName, children: this.splitTitle(pageTitle) });
    };
    LvFalconNavigator.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f;
        var stickyPricePresent = (_a = this.props.page) === null || _a === void 0 ? void 0 : _a.questions.some(function (e) { var _a; return e.type === "stickyPrice" || e.type === "annualHomeStickyPrice" || ((_a = e.questions) === null || _a === void 0 ? void 0 : _a.some(function (ee) { return ee.type === "annualHomeStickyPrice"; })); });
        var stickyPricePadding = stickyPricePresent && this.showProgressBar ? " padding-top-80-not-important" : "";
        var isNotDLNVerificationPage = !((_c = (_b = this.props.interaction) === null || _b === void 0 ? void 0 : _b.uistate) === null || _c === void 0 ? void 0 : _c.isDLNVerificationPage);
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [this.showBackground && ((0, jsx_runtime_1.jsx)("div", { className: "journey-new-bg", style: this.state.backgroundStyle })), this.mapInteractionToDataLayer(), this.renderHeader(), this.renderProgressBar(), (0, jsx_runtime_1.jsxs)("div", { className: "journey-content".concat(stickyPricePadding), children: [(0, jsx_runtime_1.jsxs)("div", { className: "journey-questions", children: [this.showTitle ? ((0, jsx_runtime_1.jsxs)("div", { className: "journey-questions-title", children: [(((_d = this.props.page) === null || _d === void 0 ? void 0 : _d.pageId) !== "decline")
                                            && (this.props.process === 'nb' || this.props.process.startsWith("mta"))
                                            && (!!((_e = this.props.page) === null || _e === void 0 ? void 0 : _e.pageId) && !((_f = this.props.page) === null || _f === void 0 ? void 0 : _f.pageId.toLowerCase().includes("tierdecline"))) &&
                                            (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [this.renderPageTitle(), (0, jsx_runtime_1.jsx)(MaintenanceBannerWidget_1.MaintenanceBannerWidget, { product: this.props.product })] }), this.props.process === 'nb' && this.renderAllianzOnlineBadge(true)] })) : (this.props.process === 'nb' &&
                                    (0, jsx_runtime_1.jsx)("div", { className: "journey-questions-no-title", children: this.renderAllianzOnlineBadge(false) })), (0, jsx_runtime_1.jsx)("div", { className: "journey-questions-body", children: (0, jsx_runtime_1.jsx)("div", { className: "journey-questions-body-content", children: this.props.children }) })] }), (this.props.page && isNotDLNVerificationPage && (this.props.page.nextPage || this.props.page.prevPage)) &&
                            (0, jsx_runtime_1.jsx)("div", { className: "journey-buttons", children: (0, jsx_runtime_1.jsxs)("div", { className: "journey-buttons-content", children: [this.renderNextButton(), this.renderBackButton()] }) })] }), this.renderFooter()] }));
    };
    LvFalconNavigator.prototype.clickPrev = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.clickPrev.call(this)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.props.engine.validate()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    LvFalconNavigator.prototype.preClickNext = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.target.focus();
                        return [4 /*yield*/, this.clickNext()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LvFalconNavigator.prototype.clickNext = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, _super.prototype.clickNext.call(this)];
                    case 1:
                        _c.sent();
                        if ((0, commonFunctions_1.isPageValid)(this.props.pageValidations, this.props.validations)) {
                            this.props.engine.setJourneyState((_a = {},
                                _a["hidePageValidationErrorMessage"] = true,
                                _a["hideUnansweredWarning"] = true,
                                _a));
                        }
                        else {
                            this.props.engine.setJourneyState((_b = {},
                                _b["hidePageValidationErrorMessage"] = false,
                                _b["hideUnansweredWarning"] = false,
                                _b));
                        }
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    LvFalconNavigator.prototype.clickLogo = function () {
        window.location.href = "/dashboard";
    };
    LvFalconNavigator.prototype.renderBackButton = function () {
        if (!this.props.page) {
            return null;
        }
        if (this.props.page.prevPage) {
            return ((0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-back", onMouseDown: this.skipDefault, onTouchStart: this.skipDefault, onClick: this.clickPrev, id: "navigatorBack", children: this.props.page && this.props.page.prevPageLabel ? this.props.page.prevPageLabel : "Back" }));
        }
        return null;
    };
    LvFalconNavigator.prototype.renderNextButton = function () {
        if (!this.props.page) {
            return null;
        }
        if (this.props.page.nextPage) {
            var withoutBackButtonCssClass = this.isBackButtonExists() ? "" : " btn-next-without-back-button";
            var cssClasses = "btn btn-primary" + (this.isNextButtonEnabled() ? "" : " btn-disabled") + " btn-next-arrow-separate btn-next-mobile-margin" + withoutBackButtonCssClass;
            return ((0, jsx_runtime_1.jsxs)("button", { type: "button", className: cssClasses, onMouseDown: this.skipDefault, onTouchStart: this.skipDefault, onClick: this.preClickNext, id: "navigatorNext", children: [this.props.page && this.props.page.nextPageLabel ? this.props.page.nextPageLabel : "Next", (0, jsx_runtime_1.jsx)("img", { className: "arrow-next", alt: "Arrow icon", src: "/img/arrow-next.png" })] }));
        }
        return null;
    };
    LvFalconNavigator.prototype.renderProgressBar = function () {
        if (!this.showProgressBar) {
            return (0, jsx_runtime_1.jsx)(React.Fragment, {});
        }
        var percentageByPageId = this.progressBarSettings ? this.progressBarSettings.getPercentageByPageId(this.props.page.pageId) : null;
        if (percentageByPageId === null) {
            return (0, jsx_runtime_1.jsx)(React.Fragment, {});
        }
        return (0, jsx_runtime_1.jsx)(LvFlowProgressBarWidget_1.default, { percentage: percentageByPageId });
    };
    LvFalconNavigator.prototype.renderHeader = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "journey-header", children: (0, jsx_runtime_1.jsx)("div", { className: "journey-header-background", children: (0, jsx_runtime_1.jsx)("a", { className: "header-logo-link", id: "goTo".concat(services_1.resourcesHelper.THEME, "HomePage"), href: services_1.resourcesHelper.BRAND_URL, target: "_blank", "aria-label": "Link to ".concat(services_1.resourcesHelper.THEME, " home page"), children: (0, jsx_runtime_1.jsx)("img", { className: "flow-logo", src: "/".concat(services_1.resourcesHelper.THEME, "/img/brand-logo.png"), alt: "".concat(services_1.resourcesHelper.THEME, " logo icon") }) }) }) }));
    };
    LvFalconNavigator.prototype.renderFooter = function () {
        return (0, jsx_runtime_1.jsx)(Footer_1.Footer, {});
    };
    LvFalconNavigator.prototype.mapInteractionToDataLayer = function () {
        var _a, _b, _c, _d, _e;
        if (this.props.interaction) {
            var policyHolder = this.props.interaction.policyHolder ? this.props.interaction.policyHolder : null;
            var address = policyHolder && policyHolder.address ? policyHolder.address : null;
            var factors = this.props.interaction.factors ? this.props.interaction.factors : null;
            var underwritingResult = this.props.interaction.underwritingResult && this.props.interaction.underwritingResult.length > 0 ? this.props.interaction.underwritingResult[0] : null;
            var vehicleCount = this.props.interaction.vehicles ? this.props.interaction.vehicles.length : 0;
            var startDate = this.props.interaction.headerInfo ? moment(this.props.interaction.headerInfo.startDate).format("DD/MM/YYYY") : null;
            var realEstate = this.props.interaction.realEstate && this.props.interaction.realEstate[0] ? this.props.interaction.realEstate[0] : null;
            var valuableItems = this.props.interaction.valuableItems ? this.props.interaction.valuableItems : null;
            var paymentDay = this.props.interaction.paymentDay ? this.props.interaction.paymentDay : null;
            var additionalDrivers = this.props.interaction.additionalDrivers && this.props.interaction.additionalDrivers.length > 0 ? this.props.interaction.additionalDrivers : null;
            window.LvDataLayer = {
                screenResolution: window.innerWidth + "x" + window.innerHeight,
                pageTitle: this.props.page.title,
                previousPageTitle: this.props.page.prevPage,
                partner: "lv",
                employmentStatus: policyHolder && policyHolder.employmentStatus ? this.fetchLookupValue("employmentStatus", policyHolder.employmentStatus) : null,
                maritalStatus: policyHolder && policyHolder.maritalStatus ? this.fetchLookupValue("maritalStatus", policyHolder.maritalStatus) : null,
                ukResidency: policyHolder ? policyHolder.residencyLength : null,
                ownsHome: policyHolder && policyHolder.ownsHome != null ? (policyHolder.ownsHome ? "Yes" : "No") : null,
                claimsIndicated: policyHolder && policyHolder.hasClaims != null ? (policyHolder.hasClaims ? "Y" : "N") : null,
                convictionsIndicated: policyHolder && policyHolder.hasConvictions !== null ? (policyHolder.hasConvictions ? "Yes" : "No") : null,
                yearOfBirth: policyHolder && policyHolder.dateOfBirth ? this.extractYearFromDate(policyHolder.dateOfBirth) : null,
                postCode: address ? address.outwardPostcode : null,
                postcode: address ? address.postcode : null,
                numberOfDrivers: this.isMotorProduct ? this.getNumberOfDrivers(this.props.interaction) : null,
                totalPricePerMonth: factors ? factors.premium : null,
                priceRange: !this.isWolfProduct ? this.getPriceRange(factors) : null,
                quoteReference: this.props.interaction._id,
                marketingPreferenceEmail: policyHolder ? (policyHolder.marketingPreferencesEmail ? "Y" : "N") : null,
                marketingPreferencePhone: policyHolder ? (policyHolder.marketingPreferencesPhone ? "Y" : "N") : null,
                marketingPreferencePost: policyHolder ? (policyHolder.marketingPreferencesPost ? "Y" : "N") : null,
                marketingPreferenceSms: policyHolder ? (policyHolder.marketingPreferencesSMS ? "Y" : "N") : null,
                policyReference: this.props.interaction.agreementNumber,
                failedUwRule: underwritingResult ? underwritingResult.objectName : null,
                vehicles: this.getVehicleData(),
                numberOfCars: vehicleCount,
                multipleCars: this.isMotorProduct ? (vehicleCount > 1 ? "Y" : "N") : null,
                documentMethod: policyHolder && policyHolder.sendDocumentsByPost ? "Post" : "Email",
                startingProduct: this.getDataLayerProduct(),
                coverStartDate: startDate,
                liveAlone: realEstate ? (realEstate.hasNoOtherResidents ? "Y" : "N") : null,
                homeClaimsIndicated: this.isRentersProduct ? (this.hasHomeClaims() ? "Y" : "N") : null,
                propertyType: realEstate && this.getTypeOrKindOfProperty(realEstate, true),
                kindOfProperty: realEstate && this.getTypeOrKindOfProperty(realEstate, false),
                numberOfFamilyMembers: realEstate && realEstate.adultFamilyMemberCount,
                numberOfHousemates: realEstate && realEstate.housemateCount,
                gotKids: realEstate ? (realEstate.childrenAtProperty ? "Y" : "N") : null,
                typeOfTenancy: realEstate && realEstate.furnishingType && this.fetchLookupValue("furnishingType", realEstate.furnishingType),
                numberOfBedrooms: realEstate && realEstate.bedroomCount ? realEstate.bedroomCount : null,
                numberOfBathrooms: realEstate && realEstate.bathroomCount ? realEstate.bathroomCount : null,
                includedItemsWorthMoreThan2K: valuableItems ? ((0, commonFunctions_1.calculateValuablesTotalValue)(valuableItems) > 2000 ? "Y" : "N") : null,
                wantCoverAwayFromHome: this.isRentersProduct ? (this.hasCoverAnywhere() ? "Y" : "N") : null,
                coverLimit: this.isRentersProduct && factors ? factors.insuredValue : null,
                accidentalDamageToContents: this.isRentersProduct && factors ? (factors.accidentalDamageProtection ? "Y" : "N") : null,
                homeExcess: this.isRentersProduct && factors ? factors.excessAmount : null,
                homeStartDate: this.isRentersProduct ? startDate : null,
                licenceHandy: this.isWolfProduct && policyHolder ? policyHolder.drivingLicenceHandy : null,
                title: this.isWolfProduct && policyHolder ? policyHolder.title : null,
                firstName: policyHolder ? policyHolder.firstName : null,
                lastName: policyHolder ? policyHolder.lastName : null,
                dln: policyHolder && policyHolder.licence != null ? policyHolder.licence.number : null,
                licenceType: ((_a = policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.licence) === null || _a === void 0 ? void 0 : _a.type) ? this.fetchLookupValue("drivingLicenceTypes", policyHolder.licence.type.toString()) : null,
                licenceHeldYears: this.isWolfProduct && policyHolder && policyHolder.drivingExperience ? this.fetchLookupValue("drivingExperienceOpts", policyHolder.drivingExperience.toString()) : null,
                occupation: this.isWolfProduct && policyHolder && policyHolder.occupation ? this.fetchLookupValue("wolfOccupation", policyHolder.occupation) : null,
                occupationIndustry: this.isWolfProduct && policyHolder && policyHolder.occupationIndustry ? this.fetchLookupValue("wolfOccupationIndustry", policyHolder.occupationIndustry) : null,
                hasSecondaryOccupation: this.isWolfProduct && policyHolder ? (policyHolder.hasSecondaryOccupation ? "Y" : "N") : null,
                secondaryOccupation: this.isWolfProduct && policyHolder && policyHolder.secondaryOccupation ? this.fetchLookupValue("wolfOccupation", policyHolder.secondaryOccupation) : null,
                numberOfClaims: policyHolder ? policyHolder.numberOfClaims : null,
                ukResidentOver3Years: this.isWolfProduct && policyHolder ? (policyHolder.residentOfUKMoreThanThreeYears ? "Y" : "N") : null,
                residencyTerm: this.isWolfProduct && policyHolder && policyHolder.residencyTerm ? this.fetchLookupValue("residencyTerms", policyHolder.residencyTerm.toString()) : null,
                nonMotoringConvictions: policyHolder && policyHolder.hasUnspentCriminalConvictions != null ? (policyHolder.hasUnspentCriminalConvictions ? "Y" : "N") : null,
                ncdYears: this.isWolfProduct && policyHolder && policyHolder.ncd ? policyHolder.ncd.yearCount : null,
                ncdEarningType: this.isWolfProduct && policyHolder && policyHolder.ncd && policyHolder.ncd.earningType ? this.fetchLookupValue("ncdEarnType", policyHolder.ncd.earningType.toString()) : null,
                protectedNcd: this.isWolfProduct && policyHolder && policyHolder.ncd ? (policyHolder.ncd.doNotDisclose ? "Y" : "N") : null,
                carsInHousehold: policyHolder ? policyHolder.carsInHousehold : null,
                paymentOption: this.isWolfProduct && factors ? factors.premiumType : null,
                coverType: this.isWolfProduct ? "COMPREHENSIVE" : null,
                automaticRenewal: this.isWolfProduct && policyHolder ? policyHolder.automaticRenewal : null,
                aggregatorName: this.populateAggregatorInfo(this.props.interaction),
                paymentDay: paymentDay ? paymentDay.day : null,
                addDriver: !this.isRentersProduct ? (additionalDrivers ? "Y" : "N") : null,
                annualPremium: this.isWolfProduct && factors ? factors.annualPremium : null,
                emailAddress: (_c = (_b = policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.email) === null || _b === void 0 ? void 0 : _b.trim().toLowerCase()) !== null && _c !== void 0 ? _c : null,
                mobileNumber: (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.phoneNumber) ? services_1.CommonHelpers.normalizeMobileNumberToE164(policyHolder.phoneNumber) : null,
                externalWallMaterial: realEstate && realEstate.externalWallMaterial ? this.fetchLookupValue("wallMaterial", realEstate.externalWallMaterial) : null,
                roofMaterial: realEstate && realEstate.roofMaterial ? this.fetchLookupValue("roofMaterial", realEstate.roofMaterial.toString()) : null,
                yearBuilt: realEstate && realEstate.yearBuilt ? realEstate.yearBuilt : null,
                propertyListing: realEstate && realEstate.propertyListing ? this.fetchLookupValue("propertyListing", realEstate.propertyListing) : null,
                isMainHome: realEstate && realEstate.isMainHome != null ? (realEstate.isMainHome ? "Y" : "N") : null,
                residentsType: realEstate && realEstate.residentsType ? this.fetchLookupValue("residencyUsage", realEstate.residentsType) : null,
                numberOfChildren: realEstate && realEstate.numberOfChildren ? realEstate.numberOfChildren : null,
                isLeftEmpty: realEstate && realEstate.isLeftEmpty != null ? (realEstate.isLeftEmpty ? "Y" : "N") : null,
                ownershipType: realEstate && realEstate.ownershipType ? this.fetchLookupValue("propertyOwnershipType", realEstate.ownershipType) : null,
                yearsAtProperty: policyHolder ? policyHolder.yearsAtProperty : null,
                homePolicyHolderTitle: policyHolder && policyHolder.title ? this.fetchLookupValue("homePolicyHolderTitle", policyHolder.title) : null,
                hasJointPolicyHolder: policyHolder && policyHolder.hasJointPolicyHolder != null ? (policyHolder.hasJointPolicyHolder ? "Y" : "N") : null,
                monthlyPaymentAvailable: this.props.interaction.paymentDetails ? (this.props.interaction.paymentDetails.instalmentPlan && this.props.interaction.paymentDetails.instalmentPlan.instalmentPlanParameters ? "Y" : "N") : null,
                documentsByEmail: policyHolder && policyHolder.sendDocumentsByPost ? "N" : "Y",
                homeAnnualPremium: this.isHomeProduct && factors ? factors.annualPremium : null,
                homeCoverLevel: this.isHomeProduct ? this.props.interaction.coverLevel : null,
                homeCoverTier: this.isHomeProduct ? this.props.interaction.coverTier : null,
                homeFixedAddonsBuildingAccidentalDamage: this.isHomeProduct && this.props.interaction.annualHomeFixedAddons ? (this.props.interaction.annualHomeFixedAddons.buildingAccidentalDamage ? "Y" : "N") : null,
                homeFixedAddonsContentsAccidentalDamage: this.isHomeProduct && this.props.interaction.annualHomeFixedAddons ? (this.props.interaction.annualHomeFixedAddons.contentsAccidentalDamage ? "Y" : "N") : null,
                homeFixedAddonsHomeEmergency: this.isHomeProduct && this.props.interaction.annualHomeFixedAddons ? (this.props.interaction.annualHomeFixedAddons.homeEmergency ? "Y" : "N") : null,
                homeFixedAddonsHomeLegalExpenses: this.isHomeProduct && this.props.interaction.annualHomeFixedAddons ? (this.props.interaction.annualHomeFixedAddons.homeLegalExpenses ? "Y" : "N") : null,
                coverTier: this.props.interaction.coverTier
            };
            var email = (_e = (_d = policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.email) === null || _d === void 0 ? void 0 : _d.trim().toLowerCase()) !== null && _e !== void 0 ? _e : null;
            services_1.CommonHelpers.setEmailInLvDataLayer(email);
        }
        return null;
    };
    LvFalconNavigator.prototype.splitTitle = function (title) {
        if (!title || typeof title !== "string") {
            return "";
        }
        var words = title.trim().split(/\s+/);
        var renderTitleColor = function (fromIndex) { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [words.slice(0, fromIndex).join(" "), " ", (0, jsx_runtime_1.jsx)("span", { className: "last-word", children: words.slice(fromIndex).join(" ") })] })); };
        var titleHighlightMap = {
            "Driving licence details": 2,
            "Set up direct debit": 2,
            "There is a problem": 2
        };
        var lastTwoWords = words.slice(-2).join(" ").toLowerCase();
        var wordsToHighlight = 1;
        if (lastTwoWords === "additional driver") {
            wordsToHighlight = 2;
        }
        else if (titleHighlightMap[title.trim()]) {
            wordsToHighlight = titleHighlightMap[title.trim()];
        }
        var highlightFromIndex = Math.max(0, words.length - wordsToHighlight);
        return renderTitleColor(highlightFromIndex);
    };
    LvFalconNavigator.prototype.populateAggregatorInfo = function (interaction) {
        var aggregatorName;
        var line;
        if (this.isWolfProduct && interaction.source) {
            switch (interaction.source) {
                case 'ctm':
                    aggregatorName = 'CTM';
                    break;
                case 'cnf':
                    aggregatorName = 'CONF';
                    break;
                case 'msm':
                    aggregatorName = 'MSM';
                    break;
                case 'gc':
                    aggregatorName = 'GOCO';
                    break;
                default:
                    return null;
            }
            line = "LVCar/Aggregator/".concat(aggregatorName);
            if (interaction.clickthroughTier) {
                line += '/' + interaction.clickthroughTier;
            }
            return line;
        }
        if (this.isHomeProduct && interaction.source) {
            switch (interaction.source) {
                case 'ctmhome':
                    aggregatorName = 'CTM';
                    break;
                case 'cnfhome':
                    aggregatorName = 'CONF';
                    break;
                case 'msmhome':
                    aggregatorName = 'MSM';
                    break;
                case 'gchome':
                    aggregatorName = 'GOCO';
                    break;
                default:
                    return null;
            }
            line = "LVHome/Aggregator/".concat(aggregatorName);
            if (interaction.clickthroughTier) {
                line += '/' + interaction.clickthroughTier;
            }
            return line;
        }
        return null;
    };
    LvFalconNavigator.prototype.isBackButtonExists = function () {
        if (!this.props.page) {
            return false;
        }
        return this.props.page.prevPage != null;
    };
    LvFalconNavigator.prototype.isNextButtonEnabled = function () {
        return !this.props.page.nextPageButtonCondition ||
            journey_services_1.ConditionEvaluator.evaluateCondition(this.props.journey.displayConditions, this.props.page.nextPageButtonCondition, this.props.interaction);
    };
    LvFalconNavigator.prototype.extractYearFromDate = function (date) {
        return moment(date, moment.ISO_8601).year();
    };
    LvFalconNavigator.prototype.getNumberOfDrivers = function (interaction) {
        if (interaction.policyHolder) {
            if (interaction.additionalDrivers) {
                return interaction.additionalDrivers.length + 1;
            }
            else {
                return 1;
            }
        }
        return null;
    };
    LvFalconNavigator.prototype.getPriceRange = function (factors) {
        if (factors) {
            return factors.neverLower + "-" + factors.neverHigher;
        }
        return null;
    };
    LvFalconNavigator.prototype.fetchLookupValue = function (fieldId, id) {
        var value = "";
        this.lookupService.fetchLookupValues(fieldId, "en-UK").subscribe(function (lookupValues) {
            var _a, _b;
            value = (_b = (_a = lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.find(function (entry) { return entry.id === id; })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "";
        });
        return value;
    };
    LvFalconNavigator.prototype.getVehicleData = function () {
        var _this = this;
        var vehicleInfo = [];
        if (this.props.interaction.vehicles) {
            var optionalExtras_1 = this.props.interaction.optionalExtras;
            this.props.interaction.vehicles.forEach(function (vehicle) {
                var legalProtection = optionalExtras_1 ? (optionalExtras_1.motorLegalExpenses ? "Y" : "N") : null;
                var courtesyCar = optionalExtras_1 ? (optionalExtras_1.courtesyCar ? "Y" : "N") : null;
                var courtesyCarTotalLoss = _this.setValueOrNull(optionalExtras_1, function () { return _this.getYN(optionalExtras_1 === null || optionalExtras_1 === void 0 ? void 0 : optionalExtras_1.courtesyCarTotalLoss); });
                var car = {
                    yearOfManufacture: vehicle.year,
                    fuelType: vehicle.fuelType ? _this.fetchLookupValue("vehicleFuelType", (0, commonFunctions_1.getInteractionVehicleFuelType)(vehicle.fuelType, vehicle.fuelTypeFull)) : null,
                    fuelTypeFull: vehicle.fuelTypeFull ? vehicle.fuelTypeFull : null,
                    make: vehicle.make,
                    model: vehicle.model,
                    voluntaryExcess: _this.getVoluntaryExcess(vehicle),
                    courtesyCar: courtesyCar,
                    motorLegalExpensesCost: legalProtection ? optionalExtras_1.motorLegalExpensesCost : null,
                    motorLegalExpenses: legalProtection,
                    courtesyCarCost: courtesyCar ? optionalExtras_1.courtesyCarCost : null,
                    courtesyCarTotalLoss: courtesyCarTotalLoss,
                    courtesyCarTotalLossCost: _this.setValueOrNull(courtesyCarTotalLoss, function () { return optionalExtras_1 === null || optionalExtras_1 === void 0 ? void 0 : optionalExtras_1.courtesyCarTotalLossCost; }),
                    totalPricePerMonth: vehicle.ratingOutput ? vehicle.ratingOutput.grossPremium : null,
                    pricePerMonth: vehicle.ratingOutput ? vehicle.ratingOutput.roundedPremium : null,
                    regNumberProvided: vehicle.manuallyChosen != null ? (vehicle.manuallyChosen ? "N" : "Y") : null,
                    vrn: vehicle.registrationNumber,
                    transmission: vehicle.transmission ? _this.fetchLookupValue("vehicleTransmission", vehicle.transmission) : null,
                    modifications: vehicle.hasModifications != null ? (vehicle.hasModifications ? "Y" : "N") : null,
                    trackerInstalled: _this.isWolfProduct && vehicle.trackerQuestionRequired ? (vehicle.trackerInstalled ? "Y" : "N") : null,
                    mileage: vehicle.mileage ? _this.fetchLookupValue("mileage", vehicle.mileage.toString()) : null,
                    carUsage: _this.isWolfProduct && vehicle.classOfUse ? _this.fetchLookupValue("carUsage", vehicle.classOfUse) : null,
                    breakdownCover: optionalExtras_1 ? (optionalExtras_1.breakdownCover ? "Y" : "N") : null,
                    breakdownCoverType: optionalExtras_1 && optionalExtras_1.breakdownCoverLevel ? optionalExtras_1.breakdownCoverLevel : null,
                    familyPackage: optionalExtras_1 ? (optionalExtras_1.familyPackage ? "Y" : "N") : null
                };
                vehicleInfo.push(car);
            });
        }
        return vehicleInfo;
    };
    LvFalconNavigator.prototype.getYN = function (value) {
        return value ? "Y" : "N";
    };
    LvFalconNavigator.prototype.setValueOrNull = function (condition, valueAccessor) {
        return condition != null ? valueAccessor() : null;
    };
    LvFalconNavigator.prototype.hasHomeClaims = function () {
        return this.props.interaction.claims && this.props.interaction.claims.length > 0 &&
            this.props.interaction.claims.some(function (c) { return c.claimType >= 10; });
    };
    LvFalconNavigator.prototype.getTypeOrKindOfProperty = function (realEstate, type) {
        var estateTypeSubType = realEstate.realEstateTypeSubType ? this.fetchLookupValue("realEstateTypeSubType", realEstate.realEstateTypeSubType) : null;
        if (estateTypeSubType) {
            var lastWord = estateTypeSubType.split(" ").pop();
            return lastWord ? (type ? lastWord.charAt(0).toUpperCase() + lastWord.substring(1, lastWord.length) : estateTypeSubType.replace(lastWord, "").trim()) : null;
        }
        return null;
    };
    LvFalconNavigator.prototype.hasCoverAnywhere = function () {
        return this.props.interaction.valuableItems && this.props.interaction.valuableItems.length > 0 && this.props.interaction.valuableItems.some(function (item) { return item.coverLocation === services_1.ValuableItemCoverLocation.ANYWHERE; });
    };
    LvFalconNavigator.prototype.getVoluntaryExcess = function (vehicle) {
        if (this.isMotorProduct && vehicle.excesses) {
            return vehicle.excesses.voluntaryExcess;
        }
        else if (this.isWolfProduct && vehicle.annualVehicleExcess) {
            return vehicle.annualVehicleExcess.voluntaryExcess;
        }
        return null;
    };
    LvFalconNavigator.prototype.getDataLayerProduct = function () {
        if (this.isMotorProduct) {
            return "Motor Subscription";
        }
        else if (this.isRentersProduct) {
            return "Renters";
        }
        else if (this.isWolfProduct) {
            return "Motor Annual";
        }
        return null;
    };
    LvFalconNavigator.prototype.getJourneyBackground = function () {
        var _this = this;
        setTimeout(function () {
            var _a, _b, _c;
            var backgroundCalcElements = document.querySelectorAll(".navigation-background-marker > *");
            var content = document.querySelector(".journey-questions");
            var validationError = document.querySelector(".validation-error-top");
            var elemHeight = 0;
            if (backgroundCalcElements !== null) {
                backgroundCalcElements.forEach(function (elem) {
                    elemHeight += _this.getElmHeight(elem);
                });
            }
            var errorShown = false;
            for (var _i = 0, _d = Object.keys(_this.props.validations); _i < _d.length; _i++) {
                var questionName = _d[_i];
                var validationResult = _this.props.validations[questionName];
                if (validationResult.errors && validationResult.errors.length > 0) {
                    errorShown = true;
                }
            }
            var validationElementHeight = 0;
            if (validationError !== null) {
                validationElementHeight = _this.getElmHeight(validationError) - 64;
            }
            if (content instanceof HTMLElement && elemHeight > 0) {
                var totalHeight = elemHeight + validationElementHeight;
                var bannerShown = (_c = (_b = (_a = _this.props.interaction) === null || _a === void 0 ? void 0 : _a.uistate) === null || _b === void 0 ? void 0 : _b.showDlnPriceUpdateBanner) !== null && _c !== void 0 ? _c : false;
                _this.setState({
                    errorShown: errorShown,
                    bannerShown: bannerShown,
                    backgroundStyle: { height: totalHeight + "px", top: (content.offsetTop + 3) + "px" }
                });
            }
        }, 200);
    };
    LvFalconNavigator.prototype.getElmHeight = function (node) {
        var list = [
            'margin-top',
            'margin-bottom',
            'border-top',
            'border-bottom',
            'padding-top',
            'padding-bottom',
            'height'
        ];
        var style = window.getComputedStyle(node);
        return list
            .map(function (k) { return parseInt(style.getPropertyValue(k), 10); })
            .reduce(function (prev, cur) { return prev + cur; }, 0);
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], LvFalconNavigator.prototype, "lookupService", void 0);
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.JourneyRuntimeService),
        __metadata("design:type", Object)
    ], LvFalconNavigator.prototype, "journeyRuntimeService", void 0);
    return LvFalconNavigator;
}(plugin_journey_1.NavigatorWidgetBase));
exports.default = LvFalconNavigator;
//# sourceMappingURL=LvFalconNavigator.js.map